import { render, staticRenderFns } from "./add-rule.vue?vue&type=template&id=55b8dc90&scoped=true&"
import script from "./add-rule.vue?vue&type=script&lang=js&"
export * from "./add-rule.vue?vue&type=script&lang=js&"
import style0 from "./add-rule.vue?vue&type=style&index=0&id=55b8dc90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8dc90",
  null
  
)

export default component.exports